import { default as local } from './local.json';

export default {
    ...local,
}
